import * as mobx from 'mobx'
import { DialogVM } from 'ui-framework'
import RootStore from '../RootStore'
import MediaQuery from './MediaQuery'

type Theme = 'light' | 'dark'

interface IUIStoreProps {
  theme: 'light' | 'dark'
}

export default class UIStore implements IUIStoreProps {
  public rootStore: RootStore
  public media = new MediaQuery()
  public walletUpdatePopup = new DialogVM({ transitionDelay: 200 })
  public toastDialog = new DialogVM({ transitionDelay: 200 })
  public theme: 'light' | 'dark' = (localStorage.getItem('theme') as Theme) || 'dark'

  set(prop: keyof IUIStoreProps, value: any) {
    this[prop] = value
  }

  private init() {
    mobx.reaction(
      () => this.rootStore.stakingStore.walletUpdate,
      (walletUpdate) => {
        if (walletUpdate) {
          this.walletUpdatePopup.show()
          setTimeout(() => {
            walletUpdate.switchAmounts()
            setTimeout(() => {
              this.walletUpdatePopup.hide()
            }, 2000)
          }, 2000)
        }
      }
    )
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
    this.init()
  }
}
